import { StateStorage } from 'zustand/middleware';
import { SESSION_CONFIG } from '@peptalk/shared';

interface StorageValue {
  state: unknown;
  timestamp: number;
}

/**
 * Custom storage wrapper that adds TTL (Time To Live) support
 * Data expires after SESSION_CONFIG.TTL_MS (5 days)
 */
export const createStorageWithTTL = (): StateStorage => {
  return {
    getItem: (name: string): string | null => {
      const item = localStorage.getItem(name);
      if (!item) return null;

      try {
        const { state, timestamp } = JSON.parse(item) as StorageValue;
        const now = Date.now();

        // Check if expired (5 days)
        if (now - timestamp > SESSION_CONFIG.TTL_MS) {
          console.log('[Storage] Data expired, clearing...');
          localStorage.removeItem(name);
          return null;
        }

        return JSON.stringify(state);
      } catch (error) {
        console.error('[Storage] Failed to parse stored data:', error);
        localStorage.removeItem(name);
        return null;
      }
    },

    setItem: (name: string, value: string): void => {
      try {
        const parsedValue = JSON.parse(value);
        const storageValue: StorageValue = {
          state: parsedValue,
          timestamp: Date.now(),
        };

        localStorage.setItem(name, JSON.stringify(storageValue));
      } catch (error) {
        console.error('[Storage] Failed to save data:', error);
      }
    },

    removeItem: (name: string): void => {
      localStorage.removeItem(name);
    },
  };
};